<template>
  <li>
    <ul>
      <p class="text-left">{{ item.name }}</p>
      <exo-nested-references
        class="item"
        v-for="(child, index) in item.references"
        :key="index"
        :item="child"
        @make-folder="$emit('make-folder', $event)"
      >
      </exo-nested-references>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'exo-nested-references',
  props: {
    root: Object,
    item: Object
  },

  computed: {
    isFolder() {
      return this.item.references && this.item.references.length
    }
  },

  methods: {
    makeFolder() {
      if (this.isFolder) {
        this.$emit('make-folder', this.item)
      }
    }
  }
}
</script>

<style scoped></style>
